module.exports = __webpack_public_path__ + "img/leadhouse.bea2c487.svg";